<nav class="navbar navbar-expand navbar-light">
    <a class="navbar-brand">
        <img src="./assets/images/CohLogo.jpg" class="d-inline-block" style="max-height: 75px;" alt="COH Logo" />
    </a>
    <a class="navbar-brand">{{ pageTitle }}</a>
    <ul class="navbar-nav">
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" [routerLink]="['/welcome']">
                Home
            </a>
        </li>
        <!--  <li class='nav-item'><a class='nav-link' routerLinkActive='active'
                                           [routerLinkActiveOptions]="{exact: true}"
                                           [routerLink]="['/reimbursementHistory/2134/1811984388/asc']">test Reimbursement
                       History</a>
                   </li>
           -->
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                [routerLink]="['/eligibilitysummary/v1/geteligibilitysummary/0']">
                Eligibility Summary Lookup
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                [routerLink]="['/eligibilitySummaryHistorical/0']">Eligibility Summary Historical Lookup</a>
        </li>
        <li *ngIf="canAccessExperianPayersUpload$ | async" class="nav-item">
            <a class="nav-link" routerLinkActive="active" [routerLink]="['/experianPayersUpload']">Experian Payers
                Upload</a>
        </li>
        <li *ngIf="canAccessExperianPayersUpload$ | async" class="nav-item">
            <a class="nav-link" routerLinkActive="active" [routerLink]="['/payerMapping']">Payer Mapping</a>
        </li>
        <div>
            <div *ngIf="isAuthenticated$ | async">
                <li class="nav-item">
                    <a class="nav-link">
                        <button (click)="logout()">Logout</button>
                    </a>
                </li>
            </div>
        </div>

        <div *ngIf="(isAuthenticated$ | async) === false">
            <li class="nav-item">
                <a class="nav-link">
                    <button (click)="login()">Login</button>
                </a>
            </li>
        </div>
    </ul>
</nav>